/**
 * How far the transcript may reach past its column into the frame's side
 * padding, so its scrollbar sits nearer the frame's edge. A frame that has
 * room sets it (the docked Atlas rail); without it the transcript keeps to its
 * column. The transcript pads its content by the same amount, so the
 * messages do not move.
 */
export const CHAT_SCROLL_GUTTER_VAR = "--chat-scroll-gutter";

export const CHAT_SCROLL_GUTTER = `var(${CHAT_SCROLL_GUTTER_VAR}, 0px)`;
